import React, {Component} from 'react'
import PropTypes from 'prop-types'

class StatusColumn extends Component {
    render() {
        const {readableStatus} = this.props
        const {text, value} = readableStatus
        let classStatus = ''
        switch (value) {
            case 'approved.approved':
                classStatus = 'text-success'
                break
            case 'generate.done':
                classStatus = 'text-primary'
                break
            case 'approved.pending':
                classStatus = 'text-warning'
                break
            case 'approved.rejected':
            case 'upload.error':
            case 'upload.international':
            case 'generate.failed':
                classStatus = 'text-danger'
                break
            case 'generate.update_setting':
                classStatus = 'text-info'
                break
            default:
                classStatus = 'text-muted'
        }

        return <td className="Status">
            <span className={classStatus}> {text}</span>
        </td>
    }
}

StatusColumn.propTypes = {
    readableStatus: PropTypes.object,
}

export default StatusColumn